import React from 'react'

const NotFound = () => (
  <div style={{ width: '300px', height: '300px', background: 'yellow' }}>
    <h2>NotFound 404</h2>
  </div>
)

export default NotFound
